import { useState, useEffect, useMemo } from "react";
import { Form, Button } from "reactstrap";
import { APIUS } from "../../../../../../config/apius";
import { FaCheck, FaPlus, FaSearch, FaTimes } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import swal from "sweetalert";
import "../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function ModalRoleAdd(props) {
  const token = localStorage.getItem("token");
  const [loadingMenu, setLoadingMenu] = useState(false);
  const [getDataMenu, setGetDataMenu] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchMenu, setSearchMenu] = useState("");

  const fetchParams = {
    headers: { Authorization: `${token}`, "Content-Type": "application/json" },
  };

  useEffect(() => {
    if (!props.show) return;
    setSelectedIds([]);
    setSearchMenu("");
    let active = true;

    const loadMenus = async () => {
      try {
        setLoadingMenu(true);
        const response = await APIUS.get(
          "/api/privileges/menus?page=0&limit=1000&ascending=0&search=",
          fetchParams
        );
        if (!active) return;
        const data = response?.data?.data;
        setGetDataMenu(Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []));
      } catch (error) {
        if (active) {
          setGetDataMenu([]);
          swal({
            title: "Failed",
            text: error?.response?.data?.message || "Gagal memuat daftar menu.",
            icon: "error",
            timer: 3000,
            buttons: false,
          });
        }
      } finally {
        if (active) setLoadingMenu(false);
      }
    };

    loadMenus();
    return () => { active = false; };
  }, [props.show]);

  const selectedMenus = useMemo(
    () => selectedIds.map((id) => getDataMenu.find((menu) => String(menu.id) === String(id)))
      .filter(Boolean),
    [selectedIds, getDataMenu]
  );

  const filteredMenus = useMemo(() => {
    const query = searchMenu.trim().toLowerCase();
    return getDataMenu.filter((menu) =>
      `${menu?.name || ""} ${menu?.url || ""}`.toLowerCase().includes(query)
    );
  }, [getDataMenu, searchMenu]);

  const handleSelectMenu = (menu) => {
    const id = menu?.id;
    if (id === undefined || id === null) return;
    setSelectedIds((previous) =>
      previous.some((item) => String(item) === String(id)) ? previous : [...previous, id]
    );
    setSearchMenu("");
  };

  const handleRemoveMenu = (id) => {
    setSelectedIds((previous) => previous.filter((item) => String(item) !== String(id)));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    if (!selectedIds.length) {
      swal({ title: "Pilih Menu", text: "Pilih minimal satu menu terlebih dahulu.", icon: "warning", timer: 2500, buttons: false });
      return;
    }
    try {
      const response = await APIUS.post(
        "/api/privileges/module-menus/store",
        { id_module: props.idAdd, menus: selectedIds.map((id) => ({ id_menu: id })) },
        fetchParams
      );
      if (response?.status === 200 || response?.status === 201) {
        swal({ title: "Success", text: response?.data?.message || "Menu berhasil ditambahkan.", icon: "success", timer: 3000, buttons: false });
        props.GetResponseData?.();
        props.onHide?.();
      }
    } catch (error) {
      swal({ title: "Failed", text: error?.response?.data?.message || "Gagal menambahkan menu.", icon: "error", timer: 3000, buttons: false });
    }
  });

  const isSaving = handleSubmit.isLoading;

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
      <div className="d-flex header-modal">
        <h5>Tambah Menu</h5>
        <div className="ml-auto x-close">
          <FontAwesomeIcon icon={faXmark} onClick={props.onHide} style={{ cursor: "pointer" }} />
        </div>
      </div>
      <hr />
      <Modal.Body className="modal-body">
        <Form onSubmit={(event) => handleSubmit.mutate(event)}>
          <div style={{ border: "1px solid #dce4f2", borderRadius: 12, padding: 16, background: "#fff" }}>
            <div className="d-flex align-items-start justify-content-between" style={{ gap: 12 }}>
              <div>
                <label className="label-form" style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Pilih Menu</label>
                <p style={{ color: "#7b8aaa", fontSize: 12, marginBottom: 12 }}>
                  Cari menu, lalu klik Pilih. Hapus menu terpilih melalui tanda silang.
                </p>
              </div>
              <span style={{ whiteSpace: "nowrap", borderRadius: 20, background: "#eef2ff", color: "#3658cd", padding: "6px 10px", fontWeight: 600, fontSize: 12 }}>
                {selectedIds.length} dipilih
              </span>
            </div>

            {selectedMenus.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
                {selectedMenus.map((menu) => (
                  <span key={menu.id} style={{ display: "inline-flex", alignItems: "center", gap: 7, border: "1px solid #c6d5fb", borderRadius: 20, background: "#eff4ff", padding: "7px 10px", color: "#234eae", fontWeight: 600, fontSize: 12, maxWidth: "100%" }}>
                    <span style={{ overflowWrap: "anywhere" }}>{menu.name}</span>
                    <button type="button" aria-label={`Hapus ${menu.name}`} onClick={() => handleRemoveMenu(menu.id)} style={{ border: 0, background: "transparent", color: "#234eae", cursor: "pointer", padding: 0, display: "flex", alignItems: "center" }}>
                      <FaTimes size={12} />
                    </button>
                  </span>
                ))}
              </div>
            )}

            <div style={{ border: "1px solid #dbe4f3", borderRadius: 9, background: "#fff", overflow: "hidden" }}>
                  <div style={{ padding: 10, position: "relative", borderBottom: "1px solid #e7edf6" }}>
                    <FaSearch size={15} style={{ position: "absolute", top: 24, left: 23, color: "#8fa2c2" }} />
                    <input value={searchMenu} onChange={(event) => setSearchMenu(event.target.value)} placeholder="Cari nama menu atau URL..."
                      style={{ width: "100%", border: "1px solid #d1ddf0", borderRadius: 8, padding: "10px 12px 10px 36px", outlineColor: "#4c73eb", fontSize: 13 }} />
                  </div>
                  <div style={{ maxHeight: 265, overflowY: "auto" }}>
                    {loadingMenu ? (
                      <div style={{ padding: 16, color: "#7b8aaa", textAlign: "center" }}>Memuat menu...</div>
                    ) : filteredMenus.length === 0 ? (
                      <div style={{ padding: 16, color: "#7b8aaa", textAlign: "center" }}>Menu tidak ditemukan.</div>
                    ) : filteredMenus.map((menu) => {
                      const selected = selectedIds.some((id) => String(id) === String(menu.id));
                      return (
                        <div key={menu.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, borderBottom: "1px solid #eef1f7", padding: "10px 12px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                            <span style={{ background: "#e3ecff", color: "#476be8", borderRadius: "50%", width: 34, height: 34, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><FaPlus size={12} /></span>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: 13, color: "#172844", fontWeight: 600, overflowWrap: "anywhere" }}>{menu.name}</div>
                              {menu.url && <div style={{ fontSize: 11, color: "#7c91b8", overflowWrap: "anywhere" }}>{menu.url}</div>}
                            </div>
                          </div>
                          <button type="button" disabled={selected} onClick={() => handleSelectMenu(menu)}
                            style={{ border: 0, borderRadius: 8, padding: "8px 10px", background: selected ? "#edf7ef" : "#eef3ff", color: selected ? "#28884a" : "#315fe8", cursor: selected ? "default" : "pointer", flexShrink: 0, fontSize: 12, fontWeight: 600 }}>
                            {selected ? <><FaCheck size={11} /> Dipilih</> : <><FaPlus size={11} /> Pilih</>}
                          </button>
                        </div>
                      );
                    })}
                  </div>
            </div>
          </div>

          <div className="d-flex justify-content-end" style={{ marginTop: 18, gap: 10 }}>
            <Button type="button" onClick={props.onHide} disabled={isSaving} style={{ background: "white", color: "#53647c", border: "1px solid #d3dce9", fontSize: "13px" }}>Batal</Button>
            <Button style={{fontSize: "13px"}} className="btn-modal-create" type="submit" disabled={isSaving || loadingMenu || selectedIds.length === 0}>
              {isSaving ? "Menyimpan..." : "Tambahkan"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
